import { CircularLoader } from '@modules/common/components/CircularLoader';
import { useInitializeQuantifyStoreFromEqlToken } from '@modules/oracle/hooks';
import { QuantifyChartWidget } from '@modules/quantify/components/QuantifyChartWidget';
import { QuantifyCooccurrenceToggle } from '@modules/quantify/components/QuantifyCooccurrenceToggle';
import { QuantifyQueryBuilder } from '@modules/quantify/components/QuantifyQueryBuilder';
import { useFetchQuantifyReport } from '@modules/quantify/hooks';
import { Stack } from '@mui/material';
import { EqlQuery } from 'generated/graphql';
import { useEffect, useState } from 'react';

interface OracleQuantifyStepDefinitionProps {
  isReadOnly?: boolean;
  eqlQuery?: EqlQuery;
}

export function OracleQuantifyStepDefinition({
  eqlQuery,
  isReadOnly,
}: OracleQuantifyStepDefinitionProps) {
  const [shouldExecuteQuery, setShouldExecuteQuery] = useState(false);
  const fetchQuantifyReport = useFetchQuantifyReport({
    isInitialFetch: true,
  });
  const { isLoading } = useInitializeQuantifyStoreFromEqlToken({
    isReadOnly,
    eqlQuery,
  });

  useEffect(() => {
    if (!isLoading) {
      setShouldExecuteQuery(true);
    }
  }, [isLoading]);

  useEffect(() => {
    if (!shouldExecuteQuery) {
      return;
    }

    setShouldExecuteQuery(false);
    fetchQuantifyReport();
  }, [shouldExecuteQuery, fetchQuantifyReport]);

  if (isLoading) {
    return (
      <Stack minHeight={500} alignItems="center" justifyContent="center">
        <CircularLoader />
      </Stack>
    );
  }

  return (
    <Stack direction="row" alignItems="start" spacing={4}>
      <QuantifyQueryBuilder shouldSkipCompareCTA={true} />
      <Stack flex={1} spacing={1}>
        <QuantifyChartWidget
          shouldHideTemplates={true}
          quantifyChartProps={{
            component: {
              barChart: { shouldShowToggleGroup: false },
              trendChart: {
                shouldDisableAnomaliesToggle: true,
                shouldDisableCategoryToggle: true,
              },
            },
          }}
        />
        <QuantifyCooccurrenceToggle
          components={{ FormControlLabel: { sx: { ml: 0 } } }}
        />
      </Stack>
    </Stack>
  );
}
